import * as XLSX from 'xlsx-js-style';
import type { ExcelTemplate } from '../../interfaces';
import { withHeaderStyling, setColumnWidth } from '../../utils';
import { getHeadersForCashOnCash } from './headers';
import { getPreparedDataCommon } from './mappings';
import { CashOnCashExport } from 'src/app/domain/cashflow/dto/CashOnCashExport';
import { CashFlowMiniDTO } from 'src/app/domain/cashflow/dto/CashFlowMiniDTO';

export class CashOnCashTemplate implements ExcelTemplate {

  export(exportExcelData: CashOnCashExport): XLSX.WorkBook {
    const companies = exportExcelData.mainData;
    const book = XLSX.utils.book_new();
    const firstCompanyCashFlowList = companies[0]?.cashFlowList;
    if (firstCompanyCashFlowList?.length > 0) {
      const sheet = this.getSheetForCash(exportExcelData, firstCompanyCashFlowList);
      XLSX.utils.book_append_sheet(book, sheet);
      return book;
    }
  }

  private getSheetForCash(exportExcelData: CashOnCashExport, cashFlowList: CashFlowMiniDTO[]): XLSX.WorkSheet {
    const headers = getHeadersForCashOnCash(cashFlowList);
    const preparedData = getPreparedDataCommon(exportExcelData, headers);
    const sheet = XLSX.utils.aoa_to_sheet(preparedData);
    const smallColumns = [0];
    smallColumns.forEach((index) => setColumnWidth(sheet, index, 25));
    const regularColumns = [];
    for (let i = 1; i < headers.length; i++) {
      regularColumns.push(i);
    }
    regularColumns.forEach((index) => setColumnWidth(sheet, index, 13));
    return withHeaderStyling(sheet);
  }
}


